import { styled } from 'styled-components';

import { STEP_WRAPPER_MAX_WIDTH } from './styleConstants';
import { BaseBodyText, BaseHeaderText } from './typographic-styled-components';

export const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  width: 100%;
  max-width: ${STEP_WRAPPER_MAX_WIDTH}px;
`;

export const StepHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
`;

export const StepHeaderText = styled(BaseHeaderText)`
  text-align: center;
`;

export const StepHeaderSubtext = styled(BaseBodyText)`
  text-align: center;
`;

export const StepFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;

  align-self: stretch;
`;

export const Form = styled.form`
  display: contents;
`;
